import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';
export { formatCurrency } from '../../../utils/formatUtils';

/**
 * Convierte string a ArrayBuffer para Excel
 */
const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
};

/**
 * Descarga los datos como archivo Excel
 */
export const downloadExcel = (dataToExport) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const titles = [
    'Plan',
    'Grupo',
    'Orden',
    'Suscriptor',
    'Saldo deuda cuota',
    'Seguro de incendio',
  ];

  const dataToDownload = dataToExport.map((item) => [
    item.plan,
    item.group,
    item.order,
    item.subscriber,
    item.installmentDebtBalance,
    item.fireInsurance,
  ]);

  const ws = utils.aoa_to_sheet([titles, ...dataToDownload]);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = write(wb, { bookType: 'xlsx', type: 'binary' });
  const data = new Blob([s2ab(excelBuffer)], { type: fileType });
  saveAs(data, 'Seguro_de_incendio' + fileExtension);
};
